import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Inline } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';

import type { ConversationAction } from '../../types';
import { isNestedAction as isNestedActionUtil } from '../../utils';

const styles = cssMap({
	containerStyles: {
		backgroundColor: token('color.background.neutral.subtle'),
		width: '100%',
		paddingLeft: token('space.100'),
		paddingRight: token('space.100'),
		paddingTop: token('space.075'),
		paddingBottom: token('space.075'),
		borderRadius: token('radius.small'),
	},

	buttonContentStyles: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.150'),
	},

	iconBoxStyles: {
		width: '32px',
		height: '32px',
		minWidth: '32px',
		borderStyle: 'solid',
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},

	inlineItemStyles: {
		gap: token('space.100'),
	},
});

type ActionItemSkeletonProps = {
	action?: ConversationAction;
	isShimmering?: boolean;
};

export const ActionItemSkeleton = ({
	action,
	isShimmering = true,
}: ActionItemSkeletonProps): React.JSX.Element => {
	const isNestedAction = action ? isNestedActionUtil(action) : false;
	return (
		<Box xcss={styles.containerStyles}>
			<Inline
				alignBlock="center"
				spread={isNestedAction ? 'space-between' : undefined}
				grow={isNestedAction ? 'fill' : undefined}
			>
				<Box xcss={styles.buttonContentStyles}>
					<Flex justifyContent="center" alignItems="center" xcss={styles.iconBoxStyles}>
						<Skeleton
							width={20}
							height={20}
							borderRadius={token('radius.small')}
							isShimmering={isShimmering}
						/>
					</Flex>
					<Inline xcss={styles.inlineItemStyles} alignBlock="center">
						<Skeleton
							width={280}
							height={20}
							borderRadius={token('radius.small')}
							isShimmering={isShimmering}
						/>
					</Inline>
				</Box>
				{isNestedAction && (
					<Skeleton
						width={16}
						height={16}
						borderRadius={token('radius.small')}
						isShimmering={isShimmering}
					/>
				)}
			</Inline>
		</Box>
	);
};
